import React from 'react';
import { motion } from 'framer-motion';
import { CrownIcon, CheckCircleIcon, SparklesIcon, ArrowRightIcon } from 'lucide-react';
export function VIPCard() {
  return <section className="w-full py-16 px-4 bg-gradient-to-b from-dark-base to-dark-card" data-id="element-259">
      <div className="container mx-auto max-w-4xl" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-261">
          <div className="relative bg-gradient-to-br from-neon-purple/20 via-dark-card to-neon-cyan/20 rounded-3xl overflow-hidden border-2 border-neon-cyan/30 hover:border-neon-cyan/60 transition-all duration-500 group" data-id="element-262">
            {/* Animated Glow Effect */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-263">
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-neon-cyan/10 via-neon-purple/10 to-neon-cyan/10 animate-pulse" data-id="element-264"></div>
            </div>

            {/* VIP Badge - Fixed for mobile */}
            <div className="absolute top-3 right-3 md:top-6 md:right-6 bg-gradient-to-r from-yellow-400 to-yellow-600 text-dark-base px-3 py-1.5 md:px-4 md:py-2 rounded-full font-bold text-xs md:text-sm flex items-center gap-1.5 md:gap-2 shadow-lg z-20" data-id="element-265">
              <CrownIcon className="w-3 h-3 md:w-4 md:h-4" data-id="element-266" />
              PREMIUM
            </div>

            <div className="relative z-10 p-12 md:p-12" data-id="element-267">
              {/* Header */}
              <div className="text-center mb-8" data-id="element-268">
                <div className="inline-flex items-center gap-2 bg-neon-cyan/20 px-4 py-2 rounded-full mb-4" data-id="element-269">
                  <SparklesIcon className="w-4 h-4 md:w-5 md:h-5 text-neon-cyan" data-id="element-270" />
                  <span className="text-neon-cyan font-semibold text-xs md:text-sm" data-id="element-271">
                    EXCLUSIVE ACCESS
                  </span>
                </div>

                <h2 className="text-2xl md:text-5xl font-black mb-4" data-id="element-272">
                  <span className="text-gradient-cyan" data-id="element-273">GreenHS VIP Access</span>
                </h2>

                <p className="text-lg md:text-xl text-gray-300 font-semibold mb-2" data-id="element-274">
                  30 Days Premium
                </p>
                <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto" data-id="element-275">
                  Unlock premium betting insights crafted for serious bettors
                  who want consistent 2–5 odds every day.
                </p>
              </div>

              {/* Features Grid */}
              <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-276">
                <div className="flex items-start gap-3 bg-dark-card/50 backdrop-blur-sm p-4 rounded-xl border border-neon-green/20" data-id="element-277">
                  <CheckCircleIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-green flex-shrink-0 mt-1" data-id="element-278" />
                  <div data-id="element-279">
                    <h3 className="font-bold text-sm md:text-base text-white mb-1" data-id="element-280">
                      Daily 2–5 Odds Ticket
                    </h3>
                    <p className="text-xs md:text-sm text-gray-400" data-id="element-281">
                      Delivered securely to our VIP channel
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-dark-card/50 backdrop-blur-sm p-4 rounded-xl border border-neon-green/20" data-id="element-282">
                  <CheckCircleIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-green flex-shrink-0 mt-1" data-id="element-283" />
                  <div data-id="element-284">
                    <h3 className="font-bold text-sm md:text-base text-white mb-1" data-id="element-285">
                      Handpicked Analyst Selections
                    </h3>
                    <p className="text-xs md:text-sm text-gray-400" data-id="element-286">
                      Expert analysis on every pick
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-dark-card/50 backdrop-blur-sm p-4 rounded-xl border border-neon-green/20" data-id="element-287">
                  <CheckCircleIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-green flex-shrink-0 mt-1" data-id="element-288" />
                  <div data-id="element-289">
                    <h3 className="font-bold text-sm md:text-base text-white mb-1" data-id="element-290">
                      Perfect for Disciplined Bettors
                    </h3>
                    <p className="text-xs md:text-sm text-gray-400" data-id="element-291">
                      Consistent strategy, proven results
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-dark-card/50 backdrop-blur-sm p-4 rounded-xl border border-neon-green/20" data-id="element-292">
                  <CheckCircleIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-green flex-shrink-0 mt-1" data-id="element-293" />
                  <div data-id="element-294">
                    <h3 className="font-bold text-sm md:text-base text-white mb-1" data-id="element-295">
                      Zero Noise. Just Results.
                    </h3>
                    <p className="text-xs md:text-sm text-gray-400" data-id="element-296">
                      Focus on what matters: winning
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="text-center" data-id="element-297">
                <a href="https://greenhsvip.site/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 md:gap-3 px-8 md:px-10 py-4 md:py-5 bg-gradient-to-r from-neon-cyan to-cyan-600 rounded-2xl font-black text-lg md:text-xl text-white shadow-lg hover:shadow-[0_0_40px_rgba(6,182,212,0.6)] transition-all hover:scale-105 group" data-id="element-298">
                  Subscribe Now
                  <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-2 transition-transform" data-id="element-299" />
                </a>

                <p className="text-xs md:text-sm text-gray-400 mt-4" data-id="element-300">
                  Join thousands of winning bettors today
                </p>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-neon-purple/20 rounded-full blur-3xl" data-id="element-301"></div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-neon-cyan/20 rounded-full blur-3xl" data-id="element-302"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}